// react
import React from 'react'
import {connect} from 'react-redux'
import {withRouter} from 'react-router'

// app
import AppView from '../components/App'
import {getRouterRedirect} from '../reducers/root';

/**
 * Application container
 */
class App extends React.Component {

    render() {
        return (
            <AppView {...this.props} redirect={this.props.redirect} />
        );
    }
}

const mapStateToProps = state => ({
    state,
    redirect: getRouterRedirect(state),
});

const mapDispatchToProps = dispatch => ({
    dispatch,
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));



// WEBPACK FOOTER //
// ./src/containers/App.js